/**
 * Single source of truth for which picker group each indicator FAMILY belongs
 * to — read by BOTH the scanner's shared defs (`lib/indicators/shared/mpp/*`)
 * and the chart's MPP studies (`lib/indicators/customMppIndicators.ts`). Move or
 * rename a group here once and it lands in BOTH the scanner's "+ Indicator"
 * picker and the chart's indicator dropdown, so the two catalogs stay in sync
 * for every indicator that exists in both.
 *
 * Pure data — no scanner/chart imports — so either layer (server-side scanner
 * compute or client-side chart) can read it without dragging the other's code
 * into its bundle. This is the "shared catalog" for the overlapping families;
 * single-catalog indicators (the 446-entry chart library, breadth, VPA,
 * candlesticks; the scanner's cross-sectional RS Rating) are already
 * single-source and don't appear here.
 */
export const INDICATOR_FAMILY_GROUP = {
  fm: "Force / Volume",
  rvol: "Force / Volume",
  // Groups mirror the + Criterion builder taxonomy (the "Criteria" catalog tab):
  // the dots / squeeze / Pivot Close Reversal / Bongo / Stretch / RS families
  // fold into "Afiat Signal"; Relative Momentum, Doji Reversal and the pivot
  // studies into "Pivot Studies" (the doji signal is grouped with its criteria).
  // So the indicator picker, the chart dropdown, and the catalog all group alike.
  // The keys are internal and stay as they were.
  pmc: "Pivot Studies",
  rs: "Afiat Signal",
  dots: "Afiat Signal",
  squeeze: "Afiat Signal",
  cpr: "Afiat Signal",
  bongo: "Afiat Signal",
  hlcd: "Pivot Studies",
  hljump: "Afiat Signal",
  vm: "Pivot Studies",
  jphist: "Pivot Studies",
  pps: "Pivot Studies",
  jppmc: "Pivot Studies",
  lcc: "Pivot Studies",
  pivots: "Pivot Studies",
  ocrule: "Pivot Studies",
  pstatus: "Pivot Studies",
  techrank: "Pivot Studies",
} as const;

export type IndicatorFamily = keyof typeof INDICATOR_FAMILY_GROUP;

/** The picker group both catalogs should show this family under. */
export function familyGroup(family: IndicatorFamily): string {
  return INDICATOR_FAMILY_GROUP[family];
}
